import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services/index';
import { JointConfigurationModel } from '../../../models/index';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-joint-configuration',
    templateUrl: './joint-configuration.component.html',
    styleUrls: ['./joint-configuration.component.scss'],
    standalone: false
})
export class JointConfigurationComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Output() selected: EventEmitter<JointConfigurationModel> = new EventEmitter();
    destroy$ = new Subject();
    tooltip_position = 'above';
    loading: boolean = false;
    optionList: JointConfigurationModel[];

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService
    ) {}

    ngOnInit() {
        this.getJointConfigurations();
        this.form
            .get('jointConfiguration')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => this.setEngineeredJointDiagramId(value));
    }

    setEngineeredJointDiagramId(engineeredJointIndex: number): void {
        if (engineeredJointIndex !== null) {
            this.form.get('EngineeredJointDiagramId').setValue(this.optionList.find((x) => x.jointConfigurationIndex == engineeredJointIndex)?.diagramId);
        }
    }

    getJointConfigurations(): void {
        this.form.markAllAsTouched();
        this.loading = true;
        this.iceapi
            .getJointConfigurations()
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((jointConfigurationModels) => {
                if (jointConfigurationModels.success === true) {
                    this.optionList = jointConfigurationModels.response;
                    if (this.form.get('jointConfiguration').value !== '') this.setEngineeredJointDiagramId(this.form.get('jointConfiguration').value);
                    if (this.optionList.length === 1)
                        this.form.get('jointConfiguration').setValue(this.optionList[0].jointConfigurationIndex, { emitEvent: false });
                    this.dataService.jointConfigurationList = jointConfigurationModels.response;
                } else {
                    this.user_utility.errorModelPopup(jointConfigurationModels.message);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
